module.exports = __webpack_public_path__ + "media/images/illustrations/packing_box-3d131f239a2c1617637a7899b811e354.svg";